import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import "@/App.css";

import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { QuoteDialog } from "@/components/QuoteDialog";

import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ServicesPage from "@/pages/Services";
import ServiceDetailPage from "@/pages/ServiceDetail";
import SafetyPage from "@/pages/Safety";
import CareersPage from "@/pages/Careers";
import BlogPage from "@/pages/Blog";
import BlogDetailPage from "@/pages/BlogDetail";
import ContactPage from "@/pages/Contact";
import LegalPage from "@/pages/Legal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

const PRIVACY = [
  "IDEAL ENTERPRISES respects your privacy. This page describes the limited personal information we collect through our website, how we use it, and the rights you have over it.",
  "We collect only the information you voluntarily provide via our contact, quote, and careers forms. This includes your name, email, phone, and any project / cover-letter content you submit.",
  "We use this information solely to respond to your enquiry, prepare a quote, or evaluate your application. We do not sell or share personal information with third parties for marketing purposes.",
  "If you wish to have your information removed from our records, please email contact@idealent.co.in and we will delete it within 30 days.",
];

const TERMS = [
  "Welcome to the website of IDEAL ENTERPRISES. By accessing or using this website you agree to these Terms & Conditions.",
  "All content on this site, including text, images, project descriptions, and graphics, is the property of IDEAL ENTERPRISES and is provided for informational purposes only.",
  "Quotes shared via our forms are indicative until formalised in a signed engagement letter. Scope, pricing, and delivery commitments are binding only once countersigned by an authorised representative of IDEAL ENTERPRISES.",
  "We make every reasonable effort to keep this website accurate and secure but accept no liability for any indirect loss arising from its use.",
];

function App() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteService, setQuoteService] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const openQuote = (service) => {
    if (typeof service === "string") setQuoteService(service);
    else setQuoteService("");
    setQuoteOpen(true);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar onQuoteClick={() => openQuote("")} />
        <Routes>
          <Route path="/" element={<HomePage onQuoteClick={() => openQuote("")} />} />
          <Route path="/about" element={<AboutPage onQuoteClick={() => openQuote("")} />} />
          <Route path="/services" element={<ServicesPage onQuoteClick={() => openQuote("")} />} />
          <Route path="/services/:slug" element={<ServiceDetailPage onQuoteClick={openQuote} />} />
          <Route path="/safety" element={<SafetyPage onQuoteClick={() => openQuote("")} />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<LegalPage title="Privacy Policy" content={PRIVACY} />} />
          <Route path="/terms" element={<LegalPage title="Terms & Conditions" content={TERMS} />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} defaultService={quoteService} />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
